import { twResolve } from "@/helpers/tw-resolve";

const ICON_TONE_CLASSES = {
  brand: "text-text-brand",
  "danger-secondary": "text-text-danger-secondary",
  "danger-tertiary": "text-text-danger-tertiary",
  disabled: "text-text-disabled",
  info: "text-text-info",
  "on-default-secondary": "text-text-on-default-secondary",
  "on-primary": "text-text-on-primary",
  rating: "text-rating-fill",
  secondary: "text-text-secondary",
  success: "text-text-success",
  tertiary: "text-text-tertiary",
  warning: "text-text-warning",
} as const;

const ICON_APPEARANCE_CLASSES = {
  filled: "fill-current",
  highlighted: "fill-background-brand text-text-brand",
  solid: "fill-current stroke-transparent",
} as const;

export type IconAppearance = keyof typeof ICON_APPEARANCE_CLASSES;
export type IconTone = keyof typeof ICON_TONE_CLASSES;

export interface IconProps {
  name: string;
  size?: number | string;
  appearance?: IconAppearance;
  tone?: IconTone;
}

export function Icon({ name, size = 16, appearance, tone, ...otherProps }: IconProps): React.ReactNode {
  return (
    <span
      className={twResolve(
        "shrink-0 fill-transparent",
        appearance && ICON_APPEARANCE_CLASSES[appearance],
        tone && ICON_TONE_CLASSES[tone],
      )}
      {...otherProps}
    >
      <svg aria-hidden="true" width={size} height={size} data-testid={name}>
        <use xlinkHref={`#${name}`} />
      </svg>
    </span>
  );
}
